function getToken() {
  const cookies = document.cookie;
  return (
    cookies
      .split(';')
      .find((item) => item.includes('.idToken'))
      ?.split('=')[1] || ''
  );
}

export default getToken;
